import { render, staticRenderFns } from "./historyList.vue?vue&type=template&id=2d87d009&scoped=true&"
import script from "./historyList.vue?vue&type=script&lang=js&"
export * from "./historyList.vue?vue&type=script&lang=js&"
import style0 from "./historyList.vue?vue&type=style&index=0&id=2d87d009&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d87d009",
  null
  
)

export default component.exports